import React from 'react';
import { ShieldCheck, Clock, BadgeDollarSign, ThumbsUp } from 'lucide-react';
const REASONS = [{
  title: 'Safe Soft-Wash Methods',
  description: 'We use low-pressure techniques and eco-friendly solutions to protect your delicate surfaces while eliminating grime.',
  icon: ShieldCheck
}, {
  title: 'Professional Crews',
  description: 'On-time, uniformed, and respectful technicians who treat your property like their own castle.',
  icon: Clock
}, {
  title: 'Upfront Flat-Rate Pricing',
  description: 'No hidden fees or surprise charges. The price we quote is the price you pay, guaranteed.',
  icon: BadgeDollarSign
}, {
  title: 'Satisfaction Guaranteed',
  description: 'We are not finished until you are thrilled with the results. The royal treatment, every time.',
  icon: ThumbsUp
}];
export function WhyUs() {
  return <section className="py-24 bg-navy relative" data-id="element-252">
      <div className="container mx-auto px-4" data-id="element-253">
        <div className="text-center mb-16" data-id="element-254">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-255">
            Why Choose <span className="text-electric" data-id="element-256">Rinse Kings</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-257">
          {REASONS.map((reason, idx) => <div key={idx} className="flex flex-col items-center text-center relative" data-id="element-258">
              <div className="h-20 w-20 rounded-full bg-[#0f1f38] border-2 border-gold flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(245,184,30,0.15)]" data-id="element-259">
                <reason.icon className="h-10 w-10 text-gold" data-id="element-260" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-261">
                {reason.title}
              </h3>
              <p className="text-slate-400" data-id="element-262">{reason.description}</p>
              {idx < REASONS.length - 1 && <div className="hidden lg:block absolute top-10 -right-4 w-8 h-px bg-gold/30" data-id="element-263" />}
            </div>)}
        </div>
      </div>
    </section>;
}